
<template>
  <v-switch
    color="primary"
    readonly
    hide-details
    :label="label"
    :input-value="value"
    @click="$emit('switchFlag', !value)" />
</template>
<script>
export default {
  name: 'SiteSettingsSwitchFlag',
  props: {
    labelMapping: {
      type: Object,
      default: () => {},
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    label() {
      if (this.value) {
        return this.labelMapping?.off;
      } return this.labelMapping?.on;
    },
  },
};
</script>